<template>
  <ContentSection
    :spacing="isSustainabilityArticleWithSidebar ? 'sm-margin' : 'default'"
  >
    <Container
      :indent="isSustainabilityArticleWithSidebar ? 'none' : 'center'"
      :class="{
        'sm:px-container lg:px-container-desktop':
          !isSustainabilityArticleWithSidebar,
      }"
    >
      <AnimatedContainer>
        <ul class="grid grid-cols-2 gap-x-4 md:grid-cols-3">
          <li
            v-for="(image, index) in data.images_inline"
            :key="image.id"
            :class="{ 'max-md:col-span-2': index === 0 }"
          >
            <figure>
              <ImageDownloadable
                v-if="image.image"
                class="slide-in-left aspect-[250/320] size-full select-none object-cover"
                :image="image.image"
                :aspect="250 / 320"
                :downloadable="image.downloadable"
              />

              <figcaption
                v-if="image.caption"
                class="mt-2 max-w-text text-sm text-[#ABABAB]"
              >
                {{ image.caption }}
              </figcaption>
            </figure>
          </li>
        </ul>
      </AnimatedContainer>
    </Container>
  </ContentSection>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, required: true },
})

const isSustainabilityArticleWithSidebar = inject(
  'isSustainabilityArticleWithSidebar',
  null
)
</script>
